export default "__VITE_ASSET__BFxCgYFA__"